import { IPaymentInstruction } from "../../../model/payment/PaymentInstruction";
import { IDomesticPaymentInstruction } from "../../../model/payment/DomesticPaymentInstruction";
import { IAbroadPaymentInstruction } from "../../../model/payment/AbroadPaymentInstruction";
import { PaymentInstructionTypes } from "../../../common/Constants";

export interface TPaymentInstructionPresentationModel {
  domestic?: IDomesticPaymentInstruction;
  abroad?: IAbroadPaymentInstruction;
  type: string;
}

const PaymentInstructionPresentationModel = (
  data: IPaymentInstruction
): TPaymentInstructionPresentationModel => {
  let paymentInstructionType = PaymentInstructionTypes.UPP;

  if (data.domestic) {
    paymentInstructionType = PaymentInstructionTypes.UPP;
  }
  if (data.abroad) {
    paymentInstructionType = PaymentInstructionTypes.INO;
    if (data.domestic) paymentInstructionType = PaymentInstructionTypes.UPP_INO;
  }

  return {
    domestic: data.domestic,
    abroad: data.abroad,
    type: paymentInstructionType
  };
};

export default PaymentInstructionPresentationModel;
